import React from 'react'
import {
  BlogImageContainer,
  BlogTitle,
  BlogDescription,
  BlogCategory,
  BlogTime,
  BlogAnotherInfo,
  BlogItemContainer,
} from './BlogItem.style'

const BlogItem = props => {
  const { image, name, category, description, time, url } = props.item

  return (
    <BlogItemContainer className="blog-item" to={url || '#'}>
      <div>
        <BlogImageContainer>
          <img src={image} alt="" />
        </BlogImageContainer>
        <BlogTitle>{name}</BlogTitle>
        <BlogDescription>{description}</BlogDescription>
        <BlogAnotherInfo>
          <BlogCategory>{category}</BlogCategory>
          <BlogTime>{time}</BlogTime>
        </BlogAnotherInfo>
      </div>
    </BlogItemContainer>
  )
}

export default BlogItem
